import { render, staticRenderFns } from "./CreateMenuDictModal.vue?vue&type=template&id=478154e9&v-slot=true&"
import script from "./CreateMenuDictModal.vue?vue&type=script&lang=js&"
export * from "./CreateMenuDictModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports